import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { useIdentity } from '@/composables/useIdentity'
import ConnectToMessengerNotify from '@/components/notifications/ConnectToMessengerNotify.vue'


export default _defineComponent({
  expose: [],
  setup(__props) {

const identity = useIdentity()

return (_ctx: any,_cache: any) => {
  return (_unref(identity).isRegistered)
    ? (_openBlock(), _createBlock(ConnectToMessengerNotify, { key: 0 }))
    : _createCommentVNode("v-if", true)
}
}

})